<template>
  <div class="h-screen flex w-full bg-img" id="page-login">
    <div
      class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/4 xl:w-1/3 mx-auto self-center shadow sm:shadow-md md:shadow-lg lg:shadow-lg xl:shadow-lg"
    >
      <vx-card style="background: rgba(250, 250, 250, 0.88);">
        <div class="p-8">
          <img
            src="@/assets/images/logo/startup_logo.png"
            alt="login"
            class="mx-auto"
          />
          <div class="vx-card__title mb-4 text-center">
            <h2>DSS CCMS</h2>
          </div>
          <div class="vx-card__title mb-8 text-center">
            <h4 class="mb-4">Login</h4>
            <p style="color:black;font-size:medium">
              Welcome, please login to your account.
            </p>
          </div>
          <vs-input
            v-validate="'required|email|min:3'"
            data-vv-validate-on="blur"
            name="email"
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Email"
            v-model="email"
            class="w-full no-icon-border"
          />
          <span class="text-danger text-sm">{{ errors.first("email") }}</span>

          <vs-input
            data-vv-validate-on="blur"
            v-validate="'required|min:6|max:10'"
            type="password"
            name="password"
            icon="icon icon-lock"
            icon-pack="feather"
            label-placeholder="Password"
            v-model="password"
            class="w-full mt-6 no-icon-border"
          />
          <span class="text-danger text-sm">{{
            errors.first("password")
          }}</span>

          <div class="flex flex-wrap justify-between my-5">
            <!-- <vs-checkbox color="primary" v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
            <router-link to="/pages/forgot-password"
              >Forgot Password?</router-link
            >
          </div>
          <vs-button color="success" type="filled" @click="registerUser"
            >Register</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            class="float-right"
            :disabled="!validateForm"
            @click="login"
            >Login</vs-button
          >
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "", //demo@demo.com
      password: "", //demodemo
      checkbox_remember_me: false
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != "" && this.password != "";
    }
  },
  methods: {
    login() {
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        },
        notify: this.$vs.notify
      };
      this.$store.dispatch("login", payload);
    },

    notifyAlreadyLogedIn() {
      this.$vs.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
    },
    registerUser() {
      if (
        this.$store.state.isLogedin != undefined &&
        this.$store.state.isLogedin == true
      ) {
        this.notifyAlreadyLogedIn();
        return false;
      }
      this.$router.push("/pages/register");
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #1551b1;
    }
    .bg-github {
      background-color: #333;
    }
    .vs-checkbox-primary .vs-checkbox {
      border: 2px solid #5a5757 !important;
    }
  }
}
</style>
